export class MathUtils {
  static canvasContext: CanvasRenderingContext2D = (() => {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (context) {
      return context;
    } else {
      throw new Error('Failed to create canvas context for text measurement.');
    }
  })();

  static getTextWidth(
    text: string,
    font: {
      size: number;
      family: string;
      weight: number;
    },
  ): number {
    const fontSpec = `${font.weight} ${font.size}px ${font.family}`;
    this.canvasContext.font = fontSpec;
    return this.canvasContext.measureText(text).width;
  }
}
